import React from 'react'
// icons
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
// views
import { Card, CardRow, IconWrap, TextWrap, Title, Value } from './views'

type MetricCardProps = {
  title: string
  value: React.ReactNode
  icon: React.ReactNode
  className?: string
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, icon, className }) => {
  return (
    <Card className={className}>
      <IconWrap>{icon}</IconWrap>
      <TextWrap>
        <Title>{title}</Title>
        <Value>{value}</Value>
      </TextWrap>
    </Card>
  )
}

interface Props {
  totalConversations: number
}

const AiUsageMetricsRow: React.FC<Props> = ({ totalConversations }) => {
  return (
    <CardRow>
      <MetricCard title='Total Conversations' value={totalConversations} icon={<QuestionAnswerIcon />} />
    </CardRow>
  )
}

export default AiUsageMetricsRow
